// extracted by mini-css-extract-plugin
export default {"root":"childrenModeGreetingLayout_root__Gv4AR"};